import { useAuth } from "@context/AuthContext";

/**
 * Hook to check whether the current user has admin privileges.
 *
 * The backend exposes `role` ("admin" | "tm" | "user" | "viewer") on the
 * /auth/me payload. We also accept the legacy `is_admin: true` shape for
 * backward compatibility.
 *
 * @returns true if the user is an admin, false otherwise (including no user).
 */
export const useIsAdmin = (): boolean => {
    const { user } = useAuth();
    return user?.role === "admin" || user?.is_admin === true;
};
